import { render } from "./BanderaSelector.vue?vue&type=template&id=6a3e8a1e"
import script from "./BanderaSelector.vue?vue&type=script&lang=js"
export * from "./BanderaSelector.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__